import { createFileRoute, Link } from '@tanstack/react-router'
import { OnPeriodAnalysisPage } from '@/views/refrigerant/customer/on-period-analysis-page'
import { installations, useInstallation } from '@/installation/api'

export const Route = createFileRoute(
  '/_authenticated/organization/$organizationId/_non_installer/locations/$locationId/assets/$assetId/on_period_analysis',
)({
  params: {
    parse: (rawParams) => ({ assetId: parseInt(rawParams.assetId) }),
  },
  loader: ({ context: { queryClient }, params: { assetId } }) =>
    queryClient.ensureQueryData(installations.detail(assetId)),
  component: RouteComponent,
  staticData: {
    breadcrumb: Breadcrumb,
  },
})

function RouteComponent() {
  const { assetId } = Route.useParams()
  const { data: asset } = useInstallation(assetId)
  return <OnPeriodAnalysisPage asset={asset} />
}

function Breadcrumb() {
  return (
    <Link to={Route.fullPath} params={Route.useParams()}>
      On period analysis
    </Link>
  )
}
